import { STATUS } from "./hooks/usePickerCore";
import { toast } from 'react-toastify';

export const initialState = {
    isConfigLoaded: false,
    isInitLoaded: false,
    onBookedSuccess: null,
    onInitialized: null,
    onValidateSuccess: null,
    url: null,
    device: 'desktop',
    externe: false,
    provider: null,
    dates: [],
    labels: {},
    isLoaded: false,
    pricing: [],
    loading: false,
    errorsMessages: [],
    bookings: [],
    categories: [],
    categoriesPrices: [],
    tickets: [],
    graphicEntities: [],
    styles: {
        variables: {
            primaryColor: '#565656',
            primaryTextColor: '#fff',
            secondaryColor: '#eee',
            tertiaryColor: '#e1e1e1',
            buttonsColor: '#565656',
            borderRadius: '5px',
            shadowColor: '#333',
            innerShadowColor: '#56565624'
        }
    }
};

export const reducer = (state, action) => {
    console.log(action.payload)
    switch (action.type) {
        case 'GET_CONFIG' :
            return getConfig(state, action);
        case 'GET_DATES' :
            return getDates(state, action);
        case 'GET_STEPS' :
            return getSteps(state, action);
        case 'GET_MULTI_WIDGET':
            return getMutliWidget(state, action);
        case 'GET_WIDGET':
            return getWidget(state, action);
        case 'ADD_TICKET':
            return addTicket(state, action);
        case 'DELETE_TICKET':
            return deleteTicket(state, action);
        case 'SET_FORMULA_TICKET':
            return setFormulaTicket(state, action);
        case 'SET_PASS_TICKET':
            return setPassTicket(state, action);
        case 'SET_LOADING':
            return setLoading(state, action);
        case 'SET_CURRENT_DATE':
            return setCurrentDate(state, action);
        case 'SET_CURRENT_HOUR':
            return setCurrentHour(state, action);
        case 'UPSERT_BOOKING':
            return upsertBooking(state, action);
        case 'SET_RESPONSIVE_DEVICE':
            return setResponsiveDevice(state, action);
    }
    return state;
};

const setResponsiveDevice = (state, { payload }) => {
    return { ...state, device: payload };
}

const upsertBooking = (state, { payload, status }) => {
    switch (status) {
        case STATUS.FAILURE:
            return { ...state, ...payload, errorsMessages: payload.messages };
        case STATUS.SUCCESS:
            if (state.onBookedSuccess) state.onBookedSuccess()
            return { ...state, ...payload, isConfigurationLoaded: true };
        default:
            return state
    }
};

const getConfig = (state, { payload, status }) => {
    switch (status) {
        case STATUS.SUCCESS:
            return { ...state, ...payload, isConfigurationLoaded: true };
        default:
            return state
    }
};

const getSteps = (state, { payload, status }) => {
    switch (status) {
        case STATUS.SUCCESS:
            payload.steps[0].current = true;
            return { ...state, dates: payload.steps, isInitLoaded: true };
        default:
            return state
    }
};

const getDates = (state, { payload, status }) => {
    switch (status) {
        case STATUS.SUCCESS:
            payload[0].current = true;
            return { ...state, dates: payload, isInitLoaded: true };
        default:
            return state
    }
};

const getMutliWidget = (state, { payload, status }) => {
    switch (status) {
        case STATUS.FETCH:
            return { ...state, loading: true };
        case STATUS.SUCCESS:
            payload.forEach(widget => {
                state.dates.map(date => {
                    if (date.at === widget.startDate) {
                        //  banane 0000
                        //date.hours['0000'].widget = widget
                        Object.keys(date.hours).forEach(value => {
                            if (date.hours[value].roomId === widget.roomId && value === widget.startHour) {
                                date.hours[value].widget = widget;
                            }
                        });
                    }
    
                    return date
                })
            })
            return { ...state, isLoaded: true };
        default:
            return { ...state }
    }
};

const getWidget = (state, { payload, status }) => {
    console.log(payload)
    switch (status) {
        case STATUS.FETCH:
            return { ...state, loading: true };
        case STATUS.SUCCESS:
            state.dates.forEach(date => {
                console.log(date)
                if (date.current) {
                    Object.keys(date.hours).forEach(value => {
                        if (date.hours[value].current) {
                            date.hours[value].widget = payload;
                        }
                    });
                }
            });
            return { ...state, isLoaded: true };
        default:
            return { ...state }
    }
};

const addTicket = (state, { payload }) => {
    if (state.device === 'phone') {
        toast(`La place a été correctement ajoutée à votre liste !`, {
            type: "success"
        });
    }
    // console.log('addTicket')
    const currentDate = state.dates.find(date => date.current);
    let currentHourValue = Object.keys(currentDate.hours).find(value => currentDate.hours[value].current);
    if(currentHourValue === undefined){
        currentHourValue = Object.keys(currentDate.hours)[0]
    }

    payload.at = currentDate.at;
    //  banane 0000
    payload.hour = currentHourValue;
    //payload.hour = state.typeWidget === 'FREE' ? currentHourValue : '0000';
    payload.uniqId = Math.random()
    payload.passCode = state.otiPassCode == null ? payload.passCode : state.otiPassCode
    state.tickets.push(payload);

    return { ...state };
};

const deleteTicket = (state, { payload }) => {
    const tickets = state.tickets.filter(ticket => {
        return ticket.uniqId !== payload.uniqId || ticket.type !== payload.type;
    });
    return { ...state, tickets }
};

const setFormulaTicket = (state, { payload }) => {
    state.tickets.forEach(ticket => {
        if (ticket.uniqId === payload.ticket.uniqId && ticket.type === payload.ticket.type) {
            ticket.formulaCode = payload.formula.formulaCode;
        }
    });
    return { ...state };
};

const setPassTicket = (state, { payload }) => {
    state.tickets.forEach(ticket => {
        if (ticket.uniqId === payload.ticket.uniqId && ticket.type === payload.ticket.type) {
            ticket.passCode = payload.passCode;
        }
    });
    return { ...state };
};

const setLoading = (state, action) => {
    return { ...state, loading: action.payload };
};

const setCurrentDate = (state, action) => {
    // console.log("setCurrentDate" )
    // console.log("state.dates", state.dates )
    console.log("action.payload", action.payload )
    state.dates.forEach(date => {
        date.current = false
        let current = parseInt(date.at) === parseInt(action.payload.at);
        // console.log('current: ', current)
        // console.log('action.payload.hours: ', action.payload.hours)
        // console.log('Object.values(action.payload.hours).length: ', Object.values(action.payload.hours).length)
        // console.log('current && action.payload.hours && action.payload.hours.length > 0: ', current && action.payload.hours && action.payload.hours.length > 0)
        // if (current && action.payload.hours && Object.values(action.payload.hours).length > 0) {
        if (current && action.payload.hours && Object.values(action.payload.hours).length > 0 && action.payload.hours !== 'undefined') {
            let isCurrentHour = false
            Object.keys(date.hours).forEach(value => {
                // console.log(value)
                // console.log(action.payload.hours.hasOwnProperty(value))
                // date.hours[value].current = parseInt(action.payload.hours[0].at) === parseInt(value)
                date.hours[value].current = action.payload.hours.hasOwnProperty(value)
                if (action.payload.hours[0] && action.payload.hours[0].at) {
                    date.hours[value].current = parseInt(action.payload.hours[0].at) === parseInt(value)
                }
                isCurrentHour = date.hours[value].current
            });
            date.current = isCurrentHour
        // } else if (current && (!action.payload.hours || Object.values(action.payload.hours).length === 0)) {
        } else if (current && (!action.payload.hours || Object.values(action.payload.hours).length === 0 || action.payload.hours === 'undefined')) {
            const valuesHours = Object.keys(date.hours);
            date.hours[valuesHours[0]].current = true;
            date.current = current
        } else {
            Object.keys(date.hours).forEach(value => date.hours[value].current = false);
            date.current = current
        }
    });
    return { ...state };
};

const setCurrentHour = (state, action) => {
    // console.log(state.dates)
    // console.log(action.payload)
    state.dates.forEach(date => {
        // console.log(date.current)
        if (date.current) {
            Object.keys(date.hours).forEach(value => {
                // console.log(value)
                date.hours[value].current = action.payload === value;
            });
        } else {
            Object.keys(date.hours).forEach(value => {
                date.hours[value].current = false;
            });
        }
    });
    return { ...state };
};